module.exports = __webpack_public_path__ + "static/media/Cubchoo_gaussian2.aed86c30.png";